<template>
  <div>
    <h4 class="mb-4">{{ componentData.compTitle }}</h4>
    <b-form-group
      class="component-field"
      description="How the element's variable will be named."
    >
      <h6>Variable Name</h6>
      <b-form-input
        v-model="componentData.data.variableName"
        placeholder="Enter the variable name"
        :state="notEmpty(componentData.data.variableName)"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "InputWidget",
  props: ["componentData"],
  // created() {
  //   console.log(this.componentData);
  // },
  methods: {
    notEmpty(value) {
      if (value === undefined) return false;

      if (value) return true;
      else return false;
    },
  },
  computed: {
    displayElementString() {
      return this.componentData.data.variableName + " = streamlit.empty()";
    },
    isValid() {
      return this.notEmpty(this.componentData.data.variableName);
    },
  },
  watch: {
    displayElementString(newValue) {
      this.$emit("update-display-element-creation-string", {
        id: this.componentData.id,
        newValue,
      });
    },

    isValid(newValue) {
      this.$emit("update-display-element-state", { id: this.componentData.id, newValue });
    },
  },
};
</script>

<style scoped lang="scss"></style>
